$(function () {
  $('.button-link').on('click', function () {
    $(this).children()[0].click();
  });
});
